/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HoldList } from './HoldList';
import {
    HoldListFromJSON,
    HoldListFromJSONTyped,
    HoldListToJSON,
    HoldListToJSONTyped,
} from './HoldList';

/**
 * 
 * @export
 * @interface PaginatedHoldListList
 */
export interface PaginatedHoldListList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedHoldListList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedHoldListList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedHoldListList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<HoldList>}
     * @memberof PaginatedHoldListList
     */
    results: Array<HoldList>;
}

/**
 * Check if a given object implements the PaginatedHoldListList interface.
 */
export function instanceOfPaginatedHoldListList(value: object): value is PaginatedHoldListList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedHoldListListFromJSON(json: any): PaginatedHoldListList {
    return PaginatedHoldListListFromJSONTyped(json, false);
}

export function PaginatedHoldListListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedHoldListList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(HoldListFromJSON)),
    };
}

  export function PaginatedHoldListListToJSON(json: any): PaginatedHoldListList {
      return PaginatedHoldListListToJSONTyped(json, false);
  }

  export function PaginatedHoldListListToJSONTyped(value?: PaginatedHoldListList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(HoldListToJSON)),
    };
}

